// Cabinet groups that get an extra "<groupName>_ColorOnly" prompt part row in the AI Management
// dev popup, shown when the fabricator has aiSettings.colorOnly enabled - the same flag that
// gates the per-group "Color Only" checkbox in the Look AI popup. These are kitchen-only groups
// and the extra row is only added for groups actually present in the current layout, so nothing
// shows up in the bathroom / fireplace / laundry visualizers.
//
// `groupName` is hardcoded instead of being taken from the feature group's dbName on purpose:
// the PromptParts.featureGroup key has to stay stable, and dbName differs between visualizers
// (the center island cabinet is 'center Island' in kvComponent but 'Center Island Cabinet' in
// kvSceneComponent).
export const COLOR_ONLY_PROMPT_PART_SUFFIX = "_ColorOnly";

export const COLOR_ONLY_PROMPT_GROUPS: {partId: string, groupName: string}[] = [
  {partId: "top_cabinet", groupName: "Top Cabinet"},
  {partId: "bottom_cabinet", groupName: "Bottom Cabinet"},
  {partId: "center_island_cabinet", groupName: "Center Island Cabinet"},
];

// Shared by the "Color Only" checkbox in the Look AI popup ("View it in your ...") and the
// synthetic "_ColorOnly" prompt part rows in the AI Management dev popup, so both offer Color
// Only for exactly the same feature groups.
export const isColorOnlyGroup = (partId?: string): boolean => {
  return COLOR_ONLY_PROMPT_GROUPS.some(group => group.partId === partId);
};
